var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-text"},[_c('h3',{staticClass:"is-size-3"},[_vm._v(" Halaman tidak dapat diakses, Mohon untuk menggunakan versi terbaru ")])])
}]

export { render, staticRenderFns }